import inquiryQueries from '@apis/queries/inquiryQueries';
import { useQuery } from '@tanstack/react-query';

function useInquiryTypes() {
    const { data } = useQuery(inquiryQueries.types());
    return data?.filter((type) => type.isActive);
}

export default useInquiryTypes;
